import { render, staticRenderFns } from "./imgG.vue?vue&type=template&id=d3b907b0"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3b907b0')) {
      api.createRecord('d3b907b0', component.options)
    } else {
      api.reload('d3b907b0', component.options)
    }
    module.hot.accept("./imgG.vue?vue&type=template&id=d3b907b0", function () {
      api.rerender('d3b907b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgG.vue"
export default component.exports